<div class="w-full pagination py-3">
  <div class="flex md:hidden justify-center">
    <div
      class="flex flex-row items-center"
      *ngIf="showPageJump"
      [attr.aria-label]="translations.jumpToPage"
    >
      <span id="page-jump" class="dls-caption-regular pr-2"
        >{{ translations.page }}:</span
      >
      <mat-form-field class="page-jump">
        <mat-select
          [aria-label]="translations.jumpToPage"
          [value]="page"
          (selectionChange)="jumpTo($event.value)"
        >
          <mat-option
            *ngFor="let jump of jumpList; let i = index"
            [value]="jump.page"
            role="option"
            [attr.data-cy]="'pagination-option-' + i"
          >
            <span class="text-sm">{{ jump.page }}</span>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="flex items-center justify-between">
    <div
      class="hidden md:flex items-center"
      *ngIf="showNextPrev"
      [ngClass]="{
        disabled: page === 1
      }"
    >
      <mat-icon svgIcon="dls-angle-plain-left-light"></mat-icon>
      <button
        class="dls-caption-semibold"
        [attr.disabled]="page === 1 ? 'disabled' : null"
        [attr.aria-label]="translations.previous"
        (click)="previousPage()"
        data-cy="pagination-previous-page"
      >
        {{ translations.previous }}
      </button>
    </div>
    <div class="flex items-center">
      <div class="text-gray-800 overflow-hidden" *ngIf="showStats">
        <span
          class="hidden md:flex p-4 dls-caption-semibold"
          data-cy="pagination-page-range"
        >
          {{ pageRange.start | number: '1.0-0' }}
          <span
            >- {{ pageRange.end | number: '1.0-0' }} {{ translations.of }}
            {{ length | number: '1.0-0' }} {{ translations.results }}
          </span>
        </span>
      </div>
      <div class="hidden md:flex items-center" *ngIf="showPageJump">
        <span id="page-jump" class="dls-caption-regular pr-2"
          >{{ translations.page }}:</span
        >
        <mat-form-field class="page-jump">
          <mat-select
            [aria-label]="translations.jumpToPage"
            [value]="page"
            data-cy="pagination-page-jump"
            (selectionChange)="jumpTo($event.value)"
          >
            <mat-option
              *ngFor="let jump of jumpList; let i = index"
              [value]="jump.page"
              role="option"
              [attr.data-cy]="'pagination-option-' + i"
            >
              <span class="text-sm">{{ jump.page }}</span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div
      class="hidden md:flex items-center"
      *ngIf="showNextPrev"
      [ngClass]="{
        disabled: page === pages
      }"
    >
      <button
        class="dls-caption-semibold"
        (click)="nextPage()"
        [attr.disabled]="page === pages ? 'disabled' : null"
        [attr.aria-label]="translations.next"
        data-cy="pagination-next-page"
      >
        {{ translations.next }}
      </button>
      <mat-icon svgIcon="dls-angle-plain-right-light"></mat-icon>
    </div>
  </div>
</div>
